import Route from '@ember/routing/route';
import { setProperties } from '@ember/object';

class AdminProductionsViewIndexRoute extends Route {
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadInvoices.cancelAll({ resetState: true });

      setProperties(controller, {
        contact: '',
        email: '',
        amount: '',
        memo: '',
        errors: { },
      });
    }
  }
}

export default AdminProductionsViewIndexRoute;
